import type { CommonTypographyProps } from 'common/components/Typography';

export const headlineStyles: CommonTypographyProps = {
  mb: ['sp_16', 'sp_20'],
};
